

export abstract class ComponentDefinitionRepository {
   public abstract getById(id: string, renderOptions: boolean): Promise<any>;
   public abstract getAll(): Promise<any[]>;
}
